import { Action } from 'redux';
import * as Immutable from 'seamless-immutable';
import { ImmutableObject } from 'seamless-immutable';
import { isType } from 'typescript-fsa';
import { AppState } from '../../reducers';
import { EntityStore } from '../entities.reducer';
import { fetchClustersByIds, updateClusters } from './clusters.actions';
import { Story } from '../Stories/stories.reducer';

export interface Cluster {
  id: number;
  name: string;
  headline: {
    [key: string]: string;
  };
  subline: {
    [key: string]: string;
  };
  text: {
    [key: string]: string;
  };
  stories: number[] | Story[];
  country: string;
  loading: boolean;
}

export interface Clusters extends EntityStore<Cluster> {}

type ClusterState = Clusters & ImmutableObject<Clusters>;

const initialState = Immutable.from<Clusters>({
  byId: {},
});
export default function reduce(
  state: ClusterState = initialState,
  action: Action
) {
  if (isType(action, updateClusters)) {
    return state.merge({
      byId: action.payload,
    } as any);
  }

  if (isType(action, fetchClustersByIds)) {
    return state.merge({
      byId: action.payload,
    } as any);
  }

  return state;
}

export function getClustersMappedById(
  state: AppState
): { [key: number]: Cluster } | {} {
  const { entities } = state;

  return entities && entities.clusters ? entities.clusters : {};
}

export function getClustersByIds(
  state: AppState,
  ids: number[]
): Cluster[] | undefined {
  const {
    entities: { clusters },
  } = state;
  return ids && ids.map(id => clusters && clusters.byId && clusters.byId[id]);
}

export function getClusterById(state: AppState, clusterId: number) {
  const {
    entities: { clusters },
  } = state;
  return clusters.byId[clusterId];
}



// WEBPACK FOOTER //
// ./src/store/Entities/Clusters/clusters.reducer.ts